// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingActionMenu-module_main_button_container_WaNTN {
  bottom: 0;
  position: sticky;
  display: flex;
  justify-content: end;
  padding-right: 12px;
}

.FloatingActionMenu-module_main_button_container_full_width_Z0yCH {
  width: 100%;
  justify-content: center;
}

.FloatingActionMenu-module_main_button_container_WaNTN button {
  border-radius: 20px;
  height: 40px;
  white-space: nowrap;
  transition: all ease-in-out 200ms;
}

.FloatingActionMenu-module_main_button_container_WaNTN button:hover {
  transform: translate(0px, -4px);
}

.FloatingActionMenu-module_floating_action_box_uj8ix {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: opacity ease-in-out 300ms;
}

.FloatingActionMenu-module_floating_action_box_uj8ix button {
  box-shadow: 0 17px 10px -10px rgba(0, 0, 0, 0.4) !important;
  z-index: 2;
}

.FloatingActionMenu-module_floating_action_box_uj8ix button:hover {
  box-shadow: 0 37px 20px -15px rgba(0, 0, 0, 0.2);
}

.FloatingActionMenu-module_not_floating_box_GHl1c button {
  box-shadow: none !important;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Buttons/FloatingActionMenu.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EAEE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ","sourcesContent":[".main_button_container {\n  bottom: 0;\n  position: sticky;\n  display: flex;\n  justify-content: end;\n  padding-right: 12px;\n}\n\n.main_button_container_full_width {\n  composes: main_button_container;\n  width: 100%;\n  justify-content: center;\n}\n\n.main_button_container button {\n  border-radius: 20px;\n  height: 40px;\n  white-space: nowrap;\n  transition: all ease-in-out 200ms;\n}\n\n.main_button_container button:hover {\n  transform: translate(0px, -4px);\n}\n\n.floating_action_box {\n  position: absolute;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transition: opacity ease-in-out 300ms;\n}\n\n.floating_action_box button {\n  box-shadow: 0 17px 10px -10px rgba(0, 0, 0, 0.4) !important;\n  z-index: 2;\n}\n\n.floating_action_box button:hover {\n  box-shadow: 0 37px 20px -15px rgba(0, 0, 0, 0.2);\n}\n\n.not_floating_box button {\n  box-shadow: none !important;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_button_container": `FloatingActionMenu-module_main_button_container_WaNTN`,
	"main_button_container_full_width": `FloatingActionMenu-module_main_button_container_full_width_Z0yCH FloatingActionMenu-module_main_button_container_WaNTN`,
	"floating_action_box": `FloatingActionMenu-module_floating_action_box_uj8ix`,
	"not_floating_box": `FloatingActionMenu-module_not_floating_box_GHl1c`
};
export default ___CSS_LOADER_EXPORT___;
